import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mt-2" }
const _hoisted_2 = { class: "flex justify-center gap-6" }



import Button from 'primevue/button';

import { useSelectViewItems } from '@/composables/useSelectViewItems';
import { useViewNavigation } from '@/composables/useViewNavigation';
import { useHiddenInputs } from '@/composables/useHiddenInputs';
import CalculationViewLink from '@/components/CalculationViewLink.vue';
import ItemProductInput from '../components/ItemProductInput.vue';
import ItemValueInput from '../components/ItemValueInput.vue';
import ItemRuleInput from '../components/ItemRuleInput.vue';
import ProductMaterials from '../components/ProductMaterials.vue';
import ProductOverview from '../components/ProductOverview.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationViewForm',
  props: {
    "selectedItems": {
  type: Object,
  required: true,
},
    "selectedItemsModifiers": {},
  },
  emits: ["update:selectedItems"],
  setup(__props) {

const { isHiddenInputs } = useHiddenInputs();
const { nextViewButton, prevViewButton } = useViewNavigation();

const selectedItems = _useModel<{ [key: string]: number | null }>(__props, 'selectedItems');

const { handleNextView, isValid, isLoading, items, getItemProduct, getItemProductMaterials } =
  useSelectViewItems(selectedItems);

return (_ctx: any,_cache: any) => {
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return _withDirectives((_openBlock(), _createElementBlock("form", {
    class: "space-y-11",
    onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(handleNextView) && _unref(handleNextView)(...args)), ["prevent"]))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items)?.filter((item) => !item.is_hidden || !_unref(isHiddenInputs)), (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id
      }, [
        (item.type === 'product')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(ItemProductInput, {
                modelValue: selectedItems.value[item.id],
                "onUpdate:modelValue": ($event: any) => ((selectedItems.value[item.id]) = $event),
                item: item
              }, null, 8, ["modelValue", "onUpdate:modelValue", "item"]),
              _createVNode(ProductOverview, {
                product: _unref(getItemProduct)(item)
              }, null, 8, ["product"]),
              _createVNode(ProductMaterials, {
                materials: _unref(getItemProductMaterials)(item)
              }, null, 8, ["materials"])
            ], 64))
          : (item.type === 'rule')
            ? (_openBlock(), _createBlock(ItemRuleInput, {
                key: 1,
                item: item
              }, null, 8, ["item"]))
            : (_openBlock(), _createBlock(ItemValueInput, {
                key: 2,
                modelValue: selectedItems.value[item.id],
                "onUpdate:modelValue": ($event: any) => ((selectedItems.value[item.id]) = $event),
                item: item
              }, null, 8, ["modelValue", "onUpdate:modelValue", "item"])),
        _createElementVNode("div", _hoisted_1, [
          (item.links.length > 0)
            ? (_openBlock(), _createBlock(CalculationViewLink, {
                key: 0,
                links: item.links
              }, null, 8, ["links"]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_2, [
      (_unref(nextViewButton).title !== 'Podsumowanie')
        ? (_openBlock(), _createBlock(_unref(Button), {
            key: 0,
            type: "submit",
            class: "font-semibold",
            size: "small",
            disabled: !_unref(isValid) || _unref(isLoading)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(nextViewButton).title), 1)
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true)
    ])
  ], 32)), [
    [_directive_auto_animate]
  ])
}
}

})